import { reviewSnippetsDataAtom } from '@pages/Storefront/components/ReviewSnippets/atoms';
import { useAppSelector } from '@redux/hooks';
import { useAtomValue } from 'jotai';

export const useIsReviewSnippetsOnVendorStorefrontsEnabled = () => {
	return useAppSelector((state) => Boolean(state.vendor.vendor?.isPaid));
};

export const useShouldShowReviewSnippets = () => {
	const isReviewSnippetsOnVendorStorefrontsEnabled =
		useIsReviewSnippetsOnVendorStorefrontsEnabled();
	const reviewSnippetsData = useAtomValue(reviewSnippetsDataAtom);
	return (
		isReviewSnippetsOnVendorStorefrontsEnabled && reviewSnippetsData !== null
	);
};
